import { Component, OnInit } from '@angular/core';
import { BaseLoginComponent } from 'src/app/shared/components/base-login/base-login.component';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-collabo-portal',
  templateUrl: './collabo-portal.component.html',
  styleUrls: ['./collabo-portal.component.css', '../style/global.css'],
})
export class CollaboPortalComponent
  extends BaseLoginComponent
  implements OnInit
{
  async ngOnInit() {
    this.auth.checkLogin({
      redirectUri: this.redirectUri,
    });
  }

  async login() {
    this.spinner.show();
    const flags = await this.auth.getFlags({
      clientId: this.clientId,
      email: this.email,
      redirectUri: this.redirectUri,
    });
    this.spinner.hide();
    // フラグが立っている場合は通常通り
    if (flags.cp_products) {
      return super.login();
    }
    // そうでない場合は連携先ページへ遷移
    try {
      const config =
        environment.apps[this.clientId][
          'cportal-connect-config-for-collaboportal'
        ];

      if (!config) {
        // 設定漏れ検知
        return alert('設定が不足しています。環境変数設定を確認してください');
      }

      await super.login({
        clientId: config.clientId,
        redirectUri: config.redirectUri,
      });
    } catch (error) {
      console.log(error);
    }
  }
  // 登録サポートツール用か否か
  get isDxsales() {
    const app = environment.apps[this.clientId];
    return app.connection === 'CBPT-DxSales';
  }
  // 登録サポートツール用か否か
  get isKanri() {
    const app = environment.apps[this.clientId];
    return app.connection === 'CBPT-Kanri';
  }

  get withoutLoginLink() {
    return this.app?.cportalConfig?.forgotPassword?.withoutLogin;
  }

  /** ロゴ画像のパス取得. カスタム設定されていればそれを使う */
  get logoImagePath() {
    const imagePath =
      this.app?.cportalConfig?.logoImagePath ||
      '/assets/collabo-portal/images/logo.svg';
    return imagePath;
  }
}
